import {
  Component,
  Prop,
  h,
  Host
} from '@stencil/core';

/**
 * @slot default - Text for the tab
 */
@Component({
  tag: 'uui-button-tab',
  styleUrl: 'uui-button-tab.css',
  shadow: true
})
export class UUIButtonTab {
  /** selected tab */
  @Prop({ reflect: true, mutable: true }) active: boolean;
  /** index of the tab in a list of tabs (can't be "tabindex" because that's reserved) */
  @Prop({ reflect: true }) tabItemIndex: number | string;

  render() {
    return (
      <Host>
        <button>
          <slot />
        </button>
      </Host>
    );
  }
}
